

export const ValuesSection=()=>{
    
    const valuesBlocks=[
        {
            path:'../../../static/ic-like.png',
            header:'Quality',
            title:'Culpa nostrud commodo ea consequat aliquip reprehenderit. Veniam velit nostrud aliquip sunt.'
        },
        {
            path:'../../../static/ic-like.png',
            header:'Quality',
            title:'Culpa nostrud commodo ea consequat aliquip reprehenderit. Veniam velit nostrud aliquip sunt.'
        },
        {
            path:'../../../static/ic-like.png',
            header:'Quality',
            title:'Culpa nostrud commodo ea consequat aliquip reprehenderit. Veniam velit nostrud aliquip sunt.'
        },
    ]
    
    
    return(
        <div className="values-section __container">
            <h1>We are Createx Construction Bureau</h1>
            <span>We are rightfully considered to be the best construction company in the USA.</span>
            <div className="values-block_video -ibg">
                <img src={require('../../../static/video.png')}/>
            </div>
            <h1>Our core values</h1>
            <span>Our mission is to set the highest standards for construction sphere.</span>
            <div className="values-section_blocks-placeholder">
                {valuesBlocks.map((p,i)=>
                <>
                    <div key={i} className="values-section_block">
                        <div>
                            <img src={require(`../../../static/ic-like.png`)}/>
                        </div>
                        <div>
                            <h1>{p.header}</h1>
                            <span>
                                {p.title}
                            </span>
                        </div>
                    </div>
                    <div style={{display:`${i==valuesBlocks.length-1?'none':'block'}`}} className="divider"></div>
                </>
                    
                )}
            </div>
        </div>
    )
}